/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import templar from "assets/images/logos/gray-logos/logo-templar.png";
import newhorizons from "assets/images/logos/gray-logos/logo-newhorizons.png";
import mindef from "assets/images/logos/gray-logos/logo-md.png";
import comdciber from "assets/images/logos/gray-logos/logo-comdciber.png";
import enajum from "assets/images/logos/gray-logos/logo-enajum.png";
import EscSupDef from "assets/images/logos/gray-logos/logo-esd.png";

function FMPLogoAreaOne() {
  return (
    <MKBox py={6}>
      <Container>
        <Grid
          container
          item
          justifyContent="center"
          xs={8}
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h6" opacity={0.5}>
            Instituições que já confiam em nossos produtos e serviços
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={templar} alt="templar" width="57%" opacity={0.9} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={newhorizons} alt="newhorizons" width="57%" opacity={0.9} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={mindef} alt="mindef" width="32%" opacity={0.9} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={comdciber} alt="comdciber" width="33%" opacity={0.9} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={enajum} alt="enajum" width="40%" opacity={0.9} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={EscSupDef} alt="EscSupDef" width="35%" opacity={0.9} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FMPLogoAreaOne;
